// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"911672b5","453":"b8cbeb83"}[chunkId] + ".chunk.js";
};